import * as React from "react";
const SvgMenuIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 48, height: 49, viewBox: "0 0 48 49", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 34.7084V32.7084H40V34.7084H8ZM8 25.1699V23.1699H40V25.1699H8ZM8 15.6313V13.6313H40V15.6313H8Z" }));
export default SvgMenuIcon;
